import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import DropDown from "./DropDown";
import RenderThumbnails from "./RenderThumbnails";
import { useAppSelector, useAppDispatch } from "../hooks/hooks";
import { tableInfoConstants } from "../store/actions/types";
const RenderOptions = ({ item, handleOptionSelection, selectedValue, getSelectedOption, }) => {
    const primaryBarSelection = useAppSelector((state) => state.configuration.primaryBarSelection);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (primaryBarSelection &&
            primaryBarSelection.name === "System" &&
            selectedValue) {
            dispatch({
                type: tableInfoConstants.SET_TABLE_INFO,
                payload: selectedValue,
            });
        }
    }, [dispatch, primaryBarSelection, selectedValue]);
    if (item.dropDown) {
        return (_jsx(DropDown, { value: selectedValue || "", item: item, handleOptionSelection: handleOptionSelection }));
    }
    return (_jsx(RenderThumbnails, { item: item, handleOptionSelection: handleOptionSelection, getSelectedOption: getSelectedOption }));
};
export default RenderOptions;
